/*
 * Documentation for adding disabling or enabling Features or Elements:
 * https://docs.apryse.com/web/guides/hiding-elements#finding-dataelement-attribute-values
 *
 * Element name strings are NOT exported as typed constants by @pdftron/webviewer.
 * Source of truth for valid dataElement strings (update URL when upgrading the library):
 *   https://github.com/ApryseSDK/webviewer-ui/blob/11.11/src/constants/dataElement.js
 *
 * Feature name strings are also plain strings (UI.Feature properties typed as string, not literals).
 * Source of truth for valid feature strings (update URL when upgrading the library):
 *   https://github.com/ApryseSDK/webviewer-ui/blob/11.11/src/constants/feature.js
 *
 * ACTION ON LIBRARY UPGRADE: diff both files against the pinned version above and audit all
 * strings in PDFTRON_CONFIG.disabled_elements, view_only_elements, disabled_features, and
 * view_only_features for renames or removals.
 */
// Description: Store pdftron init options
export const PDFTRON_WEBVIEWER_OPTIONS = {
    // NOTE: Store pdftron constants in config
    licenseKey: "PreVeil, Inc.:OEM:PreVeil::B+:AMS(20270420):2F5732731FC794D0133352184F516F2F2292EC2BCD1469C2C7ED60B2329431F5C7",
    path: "/webviewer/lib",
    fullAPI: true
};

// Description: Store pdftron constants in config
export const PDFTRON_CONFIG = {
    // NOTE: DA-7860 — PDF viewer iframe route served by pdf-viewer-sw.js with a relaxed CSP.
    frame_url: "/pdf-viewer/frame",
    footer: `PDF technology powered by PDFTron SDK copyright © PDFTronTM Systems Inc., 2001-${new Date().getFullYear()}, and distributed by PreVeil under license. All rights reserved.`,
    // NOTE: disable the Elements we don't use at all
    disabled_elements: ["signaturePanel", "pageManipulationOverlayButton", "comparePanel", "loadingModal", "progressModal"],
    view_only_elements: ["saveAsButton"],
    // NOTE: disable the Features we don't use at all
    disabled_features: ["Annotations", "Download", "FilePicker", "LocalStorage", "NotesPanel", "Redaction", "MultipleViewerMerging", "ThumbnailMerging", "Measurement", "SavedSignaturesTab", "MultiViewerMode", "ThumbnailReordering"],
    view_only_features: ["Print", "Copy", "TextSelection"]
};

